import { render, staticRenderFns } from "./ChecklistActivity2Form.vue?vue&type=template&id=31b22432&"
import script from "./ChecklistActivity2Form.vue?vue&type=script&lang=js&"
export * from "./ChecklistActivity2Form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports